import React from 'react';
import MenuItem from './MenuItem';

export default function DesktopNav({ items = [], className = '' }) {
  if (items.length === 0) return null;

  return (
    <nav className={`hidden md:flex items-center gap-2 ${className}`}>
      {items.map((item) => (
        <MenuItem key={item.id} item={item} />
      ))}
    </nav>
  );
}
